import { FC, MouseEventHandler, ReactNode, SVGProps } from "react";
import { NameIdOption } from "../../../common/types/commonTypes";
import { TalentStatus } from "../../talents/types/common";
import { MessageTemplate } from "./queries";

export interface ParticipantOption extends NameIdOption {
  type: ParticipantType;
  city?: string;
  customerCompanyName?: string;
  talentStatus?: TalentStatus;
}

export type TabState = {
  index: number;
  changeMode: "auto" | "manual";
};

export type ToolbarAction = {
  disabled?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  icon: ReactNode;
  ariaLabel?: string;
};

export enum ParticipantType {
  CUSTOMER = "CUSTOMER",
  EXPERT = "EXPERT",
  TALENT = "TALENT",
  SYSTEM = "SYSTEM",
}

export type Sender = {
  id: string;
  firstName: string;
  lastName: string;
  type: ParticipantType;
  city?: "Oulu";
  // customerOrgName?: string
};

export interface Initiator {
  id: string;
  firstName: string;
  lastName: string;
  type: ParticipantType;
}

// UI only
export interface SenderDetails {
  name?: string;
  topic?: string;
  details?: string;
  icon?: FC<SVGProps<SVGSVGElement>> | ReactNode;
  messageTemplate?: MessageTemplate;
}
